import { Reducer } from 'redux'
import { AppAlertActionTypes } from './actions'

export type AppAlertState = {
  message?: string
  messageType: 'SUCCESS' | 'ERROR' | 'WARNING' | 'INFO' | 'NONE'
  showDefault?: boolean
}
export const initialState: AppAlertState = {
  message: undefined,
  messageType: 'NONE',
}
type actionType = {
  type: AppAlertActionTypes
  error: AppAlertState
}
export const reducer: Reducer<AppAlertState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case AppAlertActionTypes.UPDATE: {
      return (state = action.error)
    }
    default: {
      return state
    }
  }
}
